import { render, staticRenderFns } from "./AppBaseExternal.vue?vue&type=template&id=e9cd023e&scoped=true&"
import script from "./AppBaseExternal.vue?vue&type=script&lang=ts&"
export * from "./AppBaseExternal.vue?vue&type=script&lang=ts&"
import style0 from "./AppBaseExternal.vue?vue&type=style&index=0&id=e9cd023e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-93e13427ca/0/cache/vue-loader-npm-15.9.8-438f4d0ff0-ca4c99b261.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9cd023e",
  null
  
)

export default component.exports